export default __webpack_public_path__ + "static/bg-2a376d1b628c7b4ce7258b91c606f846.png";